import { Flipped } from 'react-flip-toolkit';
import { Team } from './types';
import { CbNotificationToggle } from '../CbNotificationToggle/CbNotificationToggle';
import { CbUser } from '../CbUser';
import { ICON_BY_NAME } from '../Icons/Icon';
import styles from './TeamItem.module.css';
export const TeamItem = ({
  team,
  onAdd,
  onRemove,
  notificationsForUserID,
  disabled = false
}: {
  team: Team;
  onAdd?: (id) => void;
  onRemove?: (id) => void;
  notificationsForUserID?: number;
  disabled?: boolean;
}) => {
  return <Flipped flipId={team.id} data-sentry-element="Flipped" data-sentry-component="TeamItem" data-sentry-source-file="TeamItem.tsx">
      <div className={styles.item}>
        <CbUser name={team.name} data-sentry-element="CbUser" data-sentry-source-file="TeamItem.tsx" />

        <div style={{
        flex: 1
      }} />

        {notificationsForUserID && <CbNotificationToggle userID={notificationsForUserID} teamID={team.id} value={team.notificationsEnabled} />}

        {!disabled && onAdd && <button className={styles.add} onClick={() => onAdd(team)}>
            <ICON_BY_NAME.plus width="15px" height="15px" />
          </button>}

        {!disabled && onRemove && <button className={styles.remove} onClick={() => onRemove(team)}>
            <ICON_BY_NAME.closecircle width="15px" height="15px" />
          </button>}
      </div>
    </Flipped>;
};